export default __webpack_public_path__ + "static/media/Chest.019e5761.svg";